import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { IconStylingModel } from '../icon/icon-styling.model';
export class BreadCrumbStylingModel extends CoreStylingModel {

  link: StylingModel;
  iconStyling: IconStylingModel;
/**
 * @hidden 
 * It is the constructor for the button component. It takes the required string values to create the button object
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
    if (this.link == null) { this.link = new StylingModel(); }
    if (this.iconStyling == null) { this.iconStyling = new IconStylingModel(); }
  }
}

function BreadCrumbStylingModel_tsickle_Closure_declarations() {
/** @type {?} */
BreadCrumbStylingModel.prototype.link;
/** @type {?} */
BreadCrumbStylingModel.prototype.iconStyling;
}

